<section
  class="relative overflow-hidden py-24 px-6 lg:px-12"
  style="background: var(--theme-bg-alt)"
  aria-label="What we do"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto">
    <div class="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-12 lg:gap-20 items-start">

      <!-- Sticky label column -->
      <div class="lg:sticky lg:top-28">
        <div class="section-label reveal">What We Do</div>
        <h2
          class="font-display font-bold mb-3 reveal stagger-1"
          style="font-size:clamp(1.625rem,3vw,2.625rem);letter-spacing:-0.025em;line-height:1.2"
        >
          {{ t('whoWeAre') }}
        </h2>
      </div>

      <!-- Cards grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (card of cards; track card.title; let i = $index) {
          <app-feature-card
            [title]="t(card.title)"
            [description]="t(card.description)"
            [variant]="card.variant"
            [index]="i"
            class="reveal block h-full"
            [class]="'stagger-' + (i + 1)"
          />
        }
      </div>

    </div>
  </div>
</section>
